import React from 'react';

import PropTypes from 'prop-types';

import { Download } from '../../assets/icons';
import { downloadFileFromURL } from '../../utils/fileDownload.helper';
import { toastNotify } from '../../utils/toastNotify';

import './TradeItem.scss';

const AgreementItem = ({ date = 'NA', propertyName = 'NA', totalInvestment = 0, actionURL = '' }) => {
  const onDownloadFile = () => {
    if (!actionURL) {
      toastNotify('error', 'Sorry, Could not download the file!');
      return;
    }
    downloadFileFromURL(actionURL);
  };

  return (
    <div className='subscriptionitem'>
      <p className='subscriptionitem__date'>{date}</p>
      <p className='subscriptionitem__property'>{propertyName}</p>
      <p className='subscriptionitem_investment'>{totalInvestment}</p>
      <div className='subscriptionitem__download' onClick={onDownloadFile}>
        <Download verticalAlign='-4px' color='#4F3D38' />
      </div>
    </div>
  );
};

AgreementItem.propTypes = {
  date: PropTypes.string,
  propertyName: PropTypes.string,
  actionURL: PropTypes.string,
};

export default AgreementItem;
